import CanalEmailModel from './CanalEmailModel'

export default class CanalEmailMicrosoftModel extends CanalEmailModel {
  constructor({
    id = 0,
    canalId = 0,
    canalEmailId = 0,
    nome = '',
    descricao = '',
    microsoftId = '',
    tokenExpiresAtUtc = '',
  } = {}) {
    super(canalId, canalEmailId, nome, descricao)
    this.id = id
    this.microsoftId = microsoftId
    this.tokenExpiresAtUtc = tokenExpiresAtUtc
  }
}
